<div class="modal-content" *ngIf="initialized">
  <div class="modal-header d-block">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">Welcome Video</h3>

      <button type="button" class="close" (click)="this.actieveModal.dismiss()" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>

  <div class="modal-body text-center">
    <iframe *ngIf="youtubeUrl" width="700" height="450" [src]="youtubeUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    <iframe *ngIf="vimeoUrl" [src]="vimeoUrl" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>

  </div>

</div>
